import { render, staticRenderFns } from "./ListCargaMedlogView.vue?vue&type=template&id=e7281962&"
import script from "./ListCargaMedlogView.vue?vue&type=script&lang=ts&"
export * from "./ListCargaMedlogView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports